<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_edit_bill === true">แก้ไขรายการใบเสร็จเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_remove_bill === true">ลบรายการใบเสร็จเรียบร้อย</v-alert>
        <v-alert type="warning" class="alert_success" v-if="alert_print_bill === true">กำลังทำการพิมพ์ใบเสร็จกรุณารอสักครู่...</v-alert>
        <v-alert type="error" class="alert_success" v-if="alert_error_welfare_card === true">{{ message_error_welfare_card }}</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="report_paymentfood">
            <div class="d-flex justify-space-between">
                <div class="img_report_paymentfood">
                    <img :src="logo_image">
                </div>
                <div class="header_report_paymentfood">
                    <div>{{ name }}</div>
                    <div>{{ address }}</div>
                    <div>โทร {{ tel }}</div>
                </div>
            </div>
            <!-- <div class="text-right">เลขที่ {{ invoice_number }}</div> -->
            <div class="text-center">ใบกำกับภาษีอย่างย่อ</div>
            <v-simple-table>
                <thead>
                    <tr>
                        <th class="text-left">
                            อาหาร
                        </th>
                        <th class="text-left">
                            จำนวน
                        </th>
                        <th class="text-right">
                            รวม
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr v-for="(detail,key) in data_bill_list" :key="key" class="cursor_order_list_paymentfood">
                        <td class="text-left">
                            <div>
                                {{ detail.name }} ({{ Intl.NumberFormat().format(detail.price) }})
                            </div>
                            <div v-if="detail.extra">
                                - ท็อปปิ้งเพิ่ม {{ detail.extra }}
                            </div>
                        </td>
                        <td class="text-left">
                            <div class="d-flex align-center">
                                <div class="mr-1">
                                    {{ Intl.NumberFormat().format(detail.amount) }}
                                </div>
                                <v-icon @click="editBill(detail)">mdi-pencil</v-icon>
                            </div>
                        </td>
                        <td class="text-right">
                            {{ Intl.NumberFormat().format(detail.total_price) }}
                        </td>
                    </tr> -->
                    <tr v-for="(detail,key) in list_food" :key="key" class="cursor_order_list_paymentfood">
                        <td class="text-left">
                            <div>
                                {{ detail.name }} ({{ Intl.NumberFormat().format(detail.price) }})
                            </div>
                            <div class="font_topping" v-if="detail.topping_name">
                                <div v-for="(topping_name,key_topping_name) in detail.topping_name" :key="key_topping_name">
                                         - {{ topping_name }} <span class="error--text">+{{ detail.toppingprice_list[key_topping_name] }}</span>
                                </div>

                            </div>
                        </td>
                        <td class="text-left">
                            <div class="d-flex align-center">
                                <div class="mr-1">
                                    {{ Intl.NumberFormat().format(detail.amount) }}
                                </div>
                                <v-icon @click="editBill(detail)">mdi-pencil</v-icon>
                            </div>
                        </td>
                        <td class="text-right">
                            {{ Intl.NumberFormat().format(detail.total_price) }}
                        </td>
                    </tr>

                    <tr>
                        <td class="text-right" colspan="2">
                            รวมเงิน
                        </td>
                        <td class="text-right" v-if="vat_service_charge_detail.vat !== 0">
                            {{ Intl.NumberFormat().format(list_food.reduce((sum, number) => { return sum + number.total_price}, 0)) }}
                        </td>
                        <td class="text-right" v-else>
                            {{ Intl.NumberFormat().format(list_food.reduce((sum, number) => { return sum + number.total_price}, 0)) - vat_percent_result }}
                        </td>
                    </tr>

                    <!-- <tr v-if="payment_amount_discount">
                        <td class="text-right" colspan="2">
                            ส่วนลด
                        </td>
                        <td class="text-right">
                            {{ Intl.NumberFormat().format(payment_amount_discount) }}
                        </td>
                    </tr>

                    <tr v-if="payment_amount_discount_percent">
                        <td class="text-right" colspan="2">
                            ส่วนลด % (เปอร์เซ็นต์)
                        </td>
                        <td class="text-right">
                            {{ Intl.NumberFormat().format(payment_amount_discount_percent) }}
                        </td>
                    </tr> -->

                     <tr v-if="vat_service_charge_detail.vat == 0 || vat_service_charge_detail.vat == 1">
                        <td class="text-right" colspan="2">
                            Vat 7 %
                        </td>
                        <td class="text-right">
                            {{ vat_percent_result }}
                        </td>
                    </tr>

                    <tr v-if="vat_service_charge_detail.check_service_charge == 1">
                        <td class="text-right" colspan="2">
                            Service Charge {{ vat_service_charge_detail.service_charge }} %
                        </td>
                        <td class="text-right">
                            {{ service_charge_result }}
                        </td>
                    </tr>

                    <tr v-if="payment_amount_discount || payment_amount_discount_percent">
                        <td class="text-right" colspan="2">
                            ส่วนลด
                        </td>
                        <td class="text-right">
                            {{ Intl.NumberFormat().format(payment_amount_discount_all) }}
                        </td>
                    </tr>

                    <tr>
                        <td class="text-right" colspan="2">
                            รวมเงินทั้งสิ้น
                        </td>
                        <td class="text-right">
                            {{ Intl.NumberFormat().format(payment_amount_total) }}
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>
    </div>
    <!-- <div class="button_qrcode_pos_table_detail d-flex">
        <v-btn dark width="100%" height="50" @click="beforePrint()">
            <div>
                <v-icon>mdi-printer</v-icon>
            </div>
            <div>
                พิมพ์ใบเสร็จ (ก่อนชำระเงิน)
            </div>
        </v-btn>
    </div> -->
    <div class="button_qrcode_pos_table_detail">
        <v-btn color="" width="100%" height="50" @click="openPaymentDiscount()">
            <div>
                เพิ่มส่วนลด
            </div>
        </v-btn>
    </div>
    <div class="button_qrcode_pos_table_detail">
        <v-btn color="#28ab28" class="white--text" width="100%" height="50" @click="openCheckBill()">
            <div>
                Check Bill
            </div>
        </v-btn>
    </div>
    <!-- <div class="button_qrcode_pos_table_detail">
        <v-btn color="error" width="100%" height="50" @click="alert_confirm_cancel_bill = true">
            <div>
                ยกเลิกบิล
            </div>
        </v-btn>
    </div> -->
    <!-- แก้ไขใบเสร็จ (อาหาร) -->
    <v-dialog v-model="open_edit_bill" persistent max-width="600px">
        <div v-if="loading_page_edit_bill === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_edit_bill === false">

            <v-card-title class="justify-space-between">
                <div class="title_font_payment_food">
                    {{ detail_edit_bill.name }} {{ Intl.NumberFormat().format(detail_edit_bill.price) }} บาท <span v-if="detail_edit_bill.extra">( ท็อปปิ้งเพิ่ม {{ detail_edit_bill.extra }} )</span>
                </div>
                <div class="cursor_order_list_paymentfood" @click="closeEditBill()">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>
            <v-card-text>
                <div class="d-flex justify-center title_font_payment_food">
                    <div @click="addNumBill('minus')" class="cursor_order_list_paymentfood">
                        <v-icon size="40">mdi-minus-circle</v-icon>
                    </div>
                    <div class="ml-2 mr-2 align-self-center">
                        {{ detail_edit_bill_amount }}
                    </div>

                    <div @click="addNumBill('plus')" class="cursor_order_list_paymentfood">
                        <v-icon size="40">mdi-plus-circle</v-icon>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" height="50" width="50%" @click="editBillSuccess()">
                    แก้ไขรายการอาหาร
                </v-btn>
                <v-btn color="error" height="50" width="50%" @click="alert_confirm_remove_bill = true">
                    ลบรายการอาหาร
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ยืนยันการลบรายการอาหาร -->
    <v-dialog v-model="alert_confirm_remove_bill" persistent max-width="600">
        <v-card>
            <v-card-title>
                ยืนยันการลบรายการอาหาร
            </v-card-title>

            <v-card-text>
                <div v-if="detail_edit_bill">
                    {{ detail_edit_bill.name }} {{ Intl.NumberFormat().format(detail_edit_bill.price) }} บาท <span v-if="detail_edit_bill.extra">( ท็อปปิ้งเพิ่ม {{ detail_edit_bill.extra }} )</span>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" @click="removeOrderSuccess()">
                    ตกลง
                </v-btn>
                <v-btn color="error" @click="alert_confirm_remove_bill = false">
                    ยกเลิก
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- พิมพ์ใบเสร็จ -->
    <!-- <v-dialog v-model="alert_confirm_before_print" persistent max-width="600">
        <v-card>
            <v-card-title>
                ต้องการพิมพ์ใบเสร็จใช่หรือไม่ ?
            </v-card-title>

            <v-card-text>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="beforePrint()">
                    ตกลง
                </v-btn>
                <v-btn color="error" @click="alert_confirm_before_print = false">
                    ยกเลิก
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> -->
    <!-- ส่วนลด -->
    <v-dialog v-model="open_payment_discount" persistent max-width="800px">
        <v-card>
            <v-card-title class="justify-space-between">
                <div>เพิ่มส่วนลด</div>
                <div class="cursor_icon_pos_table_detail" @click="open_payment_discount = false">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>

            <v-card-text>
                <div class="d-flex">
                    <div class="flex-grow-1 mr-1">
                        <v-text-field label="ส่วนลด" type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="add_payment_amount_discount" @keyup="checkTypeDiscount()" :disabled="add_payment_amount_discount_check" outlined></v-text-field>
                    </div>
                    <div class="flex-grow-1 ml-1">
                        <v-text-field label="ส่วนลด % (เปอร์เซ็นต์)" type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="add_payment_amount_discount_percent" @keyup="checkTypeDiscount()" :disabled="add_payment_amount_discount_percent_check" outlined></v-text-field>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="d-flex align-center">
                    <div v-if="payment_amount_discount_show" class="error--text mr-1">** ส่วนลดห้ามเกินกับราคารวมทั้งหมด(รวมเงินทั้งสิ้น) **</div>
                    <v-btn height="40" color="#28ab28" class="white--text" @click="paymentDiscount()" :disabled="payment_amount_discount_show">
                        เพิ่มส่วนลด
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ส่วนลด Error -->
    <v-dialog v-model="open_payment_discount_error" persistent max-width="600px">
        <v-card>
            <v-card-title>
                คำเตือน
            </v-card-title>

            <v-card-text>
                ส่วนลดห้ามเกินกับราคารวมทั้งหมด(รวมเงินทั้งสิ้น)
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text @click="open_payment_discount_error = false">
                    ตกลง
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- Check Bill (เครื่องเลข) -->
    <v-dialog v-model="open_check_bill" persistent max-width="700px">
        <div v-if="loading_page_check_bill === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_check_bill === false">
            <v-card-title class="justify-space-between flex-nowrap">
                <div>
                    <v-tabs icons-and-text>
                        <v-tab @click="page_check_bill(1)">
                            เงินสด
                            <v-icon>mdi-cash-multiple</v-icon>
                        </v-tab>
                        <v-tab @click="page_check_bill(2)">
                            ธนาคาร
                            <v-icon>mdi-qrcode-scan</v-icon>
                        </v-tab>
                        <v-tab @click="page_check_bill(3)">
                            โครงการรัฐ
                            <v-icon>mdi-ticket-percent</v-icon>
                        </v-tab>
                    </v-tabs>
                </div>
                <div class="cursor_payment_calculate" @click="open_check_bill = false">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>
            <!-- เงินสด -->
            <v-card-text v-if="type_page_check_bill == 1">
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex mb-2">
                            <v-card class="card_payment_result_payment_food mr-1">
                                <div class="payment_amount_payment_food d-flex justify-space-between">
                                    <div>ยอดชำระ</div>
                                    <div>{{ Intl.NumberFormat().format(payment_amount_total) }}</div>
                                </div>
                            </v-card>
                            <v-card color="#038cc1" class="card_payment_result_payment_food ml-1 white--text">
                                <div class="payment_amount_payment_food d-flex justify-space-between">
                                    <div>รับเงิน</div>
                                    <div>{{ payment_amount_calculate_total_show }}</div>
                                </div>
                            </v-card>
                        </div>

                        <div class="calculate_payment_food_new text-center">
                            <div @click="calculate('7')">7</div>
                            <div @click="calculate('8')">8</div>
                            <div @click="calculate('9')">9</div>
                            <div class="calculate_shortcut" @click="calculate('฿ 1000')">฿ 1000</div>
                        </div>
                        <hr class="calculate_border_bottom">
                        <div class="calculate_payment_food_new text-center">
                            <div @click="calculate('4')">4</div>
                            <div @click="calculate('5')">5</div>
                            <div @click="calculate('6')">6</div>
                            <div class="calculate_shortcut" @click="calculate('฿ 500')">฿ 500</div>
                        </div>
                        <hr class="calculate_border_bottom">
                        <div class="calculate_payment_food_new text-center">
                            <div @click="calculate('1')">1</div>
                            <div @click="calculate('2')">2</div>
                            <div @click="calculate('3')">3</div>
                            <div class="calculate_shortcut" @click="calculate('฿ 100')">฿ 100</div>
                        </div>
                        <hr class="calculate_border_bottom">
                        <div class="calculate_payment_food_new text-center">
                            <div @click="calculate('.')">
                                <v-icon size="20" color="#000000">mdi-circle-small</v-icon>
                            </div>
                            <div @click="calculate('0')">0</div>
                            <div @click="calculate('remove')">
                                <v-icon size="20" color="#000000">
                                    mdi-backspace-outline
                                </v-icon>
                            </div>
                            <div class="calculate_shortcut" @click="calculate('full')">ชำระเต็ม</div>
                        </div>

                        <div class="calculate_change_new">
                            <div class="change_all">
                                <div>เงินทอน</div>
                                <div class="text-right">{{ preview_change_money }}</div>
                            </div>
                            <div>
                                <v-btn color="rgb(3, 140, 193)" class="title_font_payment_food white--text" width="100%" height="50" @click="confirmPayment(0)">ตกลง</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- ธนาคาร -->
            <v-card-text v-if="type_page_check_bill == 2">
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <div class="payment_amount_payment_food d-flex justify-space-between">
                                <div>ยอดชำระ</div>
                                <div>{{ Intl.NumberFormat().format(payment_amount_total) }}</div>
                            </div>
                        </v-card>
                        <v-radio-group class="mt-2" v-model="type_bank" hide-details="auto">
                            <div class="d-flex">
                                <div class="d-flex">
                                    <v-radio value="0"></v-radio>
                                    <div class="mr-1">โอน</div>
                                </div>
                                <div class="d-flex">
                                    <v-radio value="1"></v-radio>
                                    <div class="mr-1">เดรบิต/เครดิต</div>
                                </div>
                            </div>
                        </v-radio-group>
                        <div class="calculate_change_new mt-16">
                            <div></div>
                            <div>
                                <v-btn color="rgb(3, 140, 193)" class="title_font_payment_food white--text" width="100%" height="50" @click="confirmPayment(1)">ตกลง</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- โครงการรัฐ -->
            <v-card-text v-if="type_page_check_bill == 3">
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <div class="payment_amount_payment_food d-flex justify-space-between">
                                <div>ยอดชำระ</div>
                                <div>{{ Intl.NumberFormat().format(payment_amount_total) }}</div>
                            </div>
                        </v-card>
                        <v-radio-group class="mt-2" v-model="state_project" @change="stateProject()" hide-details="auto">
                            <div class="d-flex">
                                <div class="d-flex">
                                    <v-radio value="0"></v-radio>
                                    <div class="mr-1">คนละครึ่ง</div>
                                </div>
                                <div class="d-flex">
                                    <v-radio value="1"></v-radio>
                                    <div class="mr-1">ร้านธงฟ้า</div>
                                </div>
                            </div>
                        </v-radio-group>
                        <div class="mb-2" v-if="state_project == 1">
                            <hr class="line_government mb-1">
                            <h3 class="mb-1">หมายเลขบัตรสวัสดิการ <span class="error--text">*</span></h3>
                            <div class="mb-1">
                                <v-text-field hide-details="auto" type="tel" @keypress="isNumber($event)" onpaste="return false" v-model="code_welfare_card" outlined></v-text-field>
                            </div>
                            <div class="pay_all">
                                <h3>ชำระจากบัตรสวัสดิการ <span class="error--text">*</span></h3>
                                <div>
                                    <h3>ชำระส่วนเกิน <span class="error--text">*</span></h3>
                                    <v-radio-group class="mt-0" v-model="welfare_card_status_excess" hide-details="auto">
                                        <div class="d-flex">
                                            <div class="d-flex">
                                                <v-radio value="0"></v-radio>
                                                <div class="mr-1">เงินสด</div>
                                            </div>
                                            <div class="d-flex">
                                                <v-radio value="1"></v-radio>
                                                <div class="mr-1">เงินโอน</div>
                                            </div>
                                        </div>
                                    </v-radio-group>
                                </div>
                                <div class="mr-1">
                                    <v-text-field hide-details="auto" type="tel" @keypress="isNumber($event)" @keyup="input_welfare_card_price('welfare_card_price')" onpaste="return false" v-model="welfare_card_price" outlined></v-text-field>
                                </div>
                                <div class="ml-1">
                                    <v-text-field hide-details="auto" type="tel" @keypress="isNumber($event)" @keyup="input_welfare_card_price('welfare_card_price_excess')" onpaste="return false" v-model="welfare_card_price_excess" outlined></v-text-field>
                                </div>
                            </div>
                        </div>
                        <div :class="state_project == 0 ? 'calculate_change_new mt-16' : 'calculate_change_new'">
                            <div></div>
                            <div>
                                <v-btn color="rgb(3, 140, 193)" class="title_font_payment_food white--text" width="100%" height="50" @click="confirmPayment(2)">ตกลง</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- พิมพ์ใบเสร็จหรือไม่หลังชำระเงินแล้ว -->
    <v-dialog v-model="alert_confirm_after_print" persistent max-width="600">
        <v-card>
            <v-card-title>
                ชำระเงินเรียบร้อยแล้ว
            </v-card-title>

            <v-card-text>
                <div v-if="payment_type == 0">
                    เงินทอน {{ change_money_bill }} บาท ต้องการพิมพ์ใบเสร็จใช่หรือไม่ ?
                </div>
                <div v-if="payment_type == 1">
                    ต้องการพิมพ์ใบเสร็จใช่หรือไม่ ?
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" @click="afterPrint(0)">
                    พิมพ์ใบเสร็จ
                </v-btn>
                <v-btn color="error" @click="afterPrint(1)">
                    ไม่พิมพ์ใบเสร็จ
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ยกเลิกบิล -->
    <v-dialog v-model="alert_confirm_cancel_bill" persistent max-width="600">
        <div v-if="loading_page_success_cancel_bill === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_success_cancel_bill === false">
            <v-form ref="form_success_cancel_bill" @submit.prevent="successCancelBill()">
                <v-card-title>
                    คำเตือน
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการยกเลิกบิล {{ invoice_number }} ใช่หรือไม่ ?
                    </div>
                    <div class="mb-2">
                        <v-select label="เหตุผลในการยกเลิกบิล" v-model="bill_cancel_description" :items="$store.state.reasonCancelBill" color="primary" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเหตุผลในการยกเลิกบิล']" @change="billCancelDescription()" required outlined>
                        </v-select>
                    </div>
                    <div class="mb-2" v-if="bill_cancel_description_reason_check">
                        <v-text-field v-model="bill_cancel_description_reason" color="primary" label="เหตุผลในการยกเลิกบิล" :rules="[v => !!v || 'กรุณากรอกเหตุผลในการยกเลิกบิล']" required outlined></v-text-field>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="cancel_cancelBill()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/ZoftConnect_Logo_Black_for_Bill_150px.png";
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            vat_service_charge_detail: null,
            vat_percent_result: 0,
            service_charge_result: 0,
            logo_image: before_image,
            name: null,
            address: null,
            tel: null,
            invoice_id: null,
            invoice_number: null,
            data_bill_list: [],
            open_edit_bill: false,
            loading_page_edit_bill: true,
            detail_edit_bill: null,
            detail_edit_bill_amount: 0,
            alert_confirm_remove_bill: false,
            alert_edit_bill: false,
            alert_remove_bill: false,
            payment_amount: 0,
            payment_amount_discount: null,
            payment_amount_discount_percent: null,
            payment_amount_discount_all: 0,
            // alert_confirm_before_print: false,
            alert_print_bill: false,
            open_payment_discount: false,
            add_payment_amount_discount: null,
            add_payment_amount_discount_check: false,
            add_payment_amount_discount_percent: null,
            add_payment_amount_discount_percent_check: false,
            payment_amount_discount_show:false,
            open_payment_discount_error:false,
            payment_amount_total: 0,
            open_check_bill: false,
            loading_page_check_bill: false,
            default_payment_amount_calculate_total: false,
            payment_amount_calculate_total: '0',
            payment_amount_calculate_total_show: '0',
            preview_change_money: '0',
            payment_type: 0,
            change_money_bill: 0,
            alert_confirm_after_print: false,
            alert_confirm_cancel_bill: false,
            loading_page_success_cancel_bill: false,
            bill_cancel_description: null,
            bill_cancel_description_reason_check: false,
            bill_cancel_description_reason: null,
            type_page_check_bill: 1,
            state_project: '0',
            code_welfare_card: null,
            welfare_card_price: null,
            welfare_card_status_excess: '0',
            welfare_card_price_excess: null,
            alert_error_welfare_card: false,
            message_error_welfare_card: null,
            type_bank: '0',
        }
    },
    props: ['token', 're_bill', 'takehome_id','list_food'],
    methods: {
        async getPaymentDetail() {
            this.loading_page = true
            this.data_bill_list = []
            this.payment_amount_discount = null
            this.payment_amount_discount_percent = null
            this.payment_amount_discount_all = 0

            this.payment_amount_total = this.list_food.reduce((sum, number) => { return sum + number.total_price}, 0)
            await HTTP.get('/detailRestarant', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.logo_image = response.data.detail.logo_image
                        this.name = response.data.detail.name
                        this.address = response.data.detail.address
                        this.tel = response.data.detail.tel

                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            this.vat_service_charge_detail = null
            this.vat_percent_result = 0
            this.service_charge_result = 0
            await HTTP.get('/vat_a_lacarte', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        const vat_list = {
        vat: response.data.vat.vat_a_la_carte,
        check_service_charge: response.data.vat.check_service_charge_a_la_carte,
        service_charge: response.data.vat.service_charge_a_la_carte,
      };
      this.vat_service_charge_detail = vat_list;

      // Apply the service charge if applicable
      if (this.vat_service_charge_detail.check_service_charge == 1) {
        let service_charge_percent = this.vat_service_charge_detail.service_charge / 100;
        this.service_charge_result = this.payment_amount_total * service_charge_percent;
        this.service_charge_result = parseFloat(this.service_charge_result.toFixed(2));
        this.payment_amount_total += this.service_charge_result; // Add service charge to total
      }

      // Apply VAT based on the updated total which includes service charge
      let vat_percent = 7 / 100;
      if (this.vat_service_charge_detail.vat == 1) {
        // VAT exclusive: Calculate and add VAT to the total
        this.vat_percent_result = this.payment_amount_total * vat_percent;
        this.vat_percent_result = parseFloat(this.vat_percent_result.toFixed(2));
        this.payment_amount_total += this.vat_percent_result;
      } else if (this.vat_service_charge_detail.vat == 0) {
        // VAT inclusive: Adjust for VAT already included in the displayed prices
        let vat_inclusive_base = this.payment_amount_total / (1 + vat_percent);
        this.vat_percent_result = this.payment_amount_total - vat_inclusive_base;
        this.vat_percent_result = parseFloat(this.vat_percent_result.toFixed(2));
        // No adjustment needed as prices are displayed VAT-inclusive
      }

      this.loading_page = false;
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

        },
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async isNumberPrice(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async editBill(detail) {
            this.open_edit_bill = true
            this.loading_page_edit_bill = true
            this.detail_edit_bill = detail
            this.detail_edit_bill_amount = detail.amount
            this.loading_page_edit_bill = false

        },
        async closeEditBill() {
            this.loading_page_edit_bill = true
            this.detail_edit_bill = null
            this.detail_edit_bill_amount = 0
            this.open_edit_bill = false
        },
        async addNumBill(type) {
            if (type === 'plus') {
                this.detail_edit_bill_amount += 1
            }
            if (type === 'minus' && this.detail_edit_bill_amount > 1) {
                this.detail_edit_bill_amount -= 1
            }
        },
        async editBillSuccess() {
            // this.loading_page = true
            this.getPaymentDetail()
            this.open_edit_bill = false
            let list_food = this.list_food.find((detail) => {
                return detail.id == this.detail_edit_bill.id
            })

            list_food.amount = this.detail_edit_bill_amount
            list_food.total_price = (list_food.price + list_food.toppingprice) * this.detail_edit_bill_amount
            this.payment_amount_total = this.list_food.reduce((sum, number) => { return sum + number.total_price}, 0)
            // HTTP.post('/POS/table/edit-order-menu/' + this.detail_edit_bill.id, {
            //         amount: this.detail_edit_bill_amount
            //     }, {
            //         headers: {
            //             "Authorization": `Bearer ${this.$store.state.token}`
            //         }
            //     })
            //     .then((response) => {
            //         if (response.data.successful === true) {
            //             this.getPaymentDetail()
            //             this.alert_edit_bill = true
            //             setTimeout(() => this.alert_edit_bill = false, 5000)
            //         }

            //     }).catch((error) => {
            //         if (error.response.status === 401) {
            //             this.$store.commit('logOutSuccess')
            //             this.$router.push('/login')
            //         }
            //     })
        },
        async removeOrderSuccess() {
            // this.loading_page = true
            // this.open_edit_bill = false
            // this.alert_confirm_remove_bill = false
            // HTTP.post('/POS/table/delete-order-menu/' + this.detail_edit_bill.id, {
            //         amount: this.detail_edit_bill_amount
            //     }, {
            //         headers: {
            //             "Authorization": `Bearer ${this.$store.state.token}`
            //         }
            //     })
            //     .then((response) => {
            //         if (response.data.successful === true) {
            //             this.getPaymentDetail()
            //             this.alert_remove_bill = true
            //             setTimeout(() => this.alert_remove_bill = false, 5000)
            //         }

            //     }).catch((error) => {
            //         if (error.response.status === 401) {
            //             this.$store.commit('logOutSuccess')
            //             this.$router.push('/login')
            //         }
            //     })


            this.open_edit_bill = false
            this.alert_confirm_remove_bill = false
            // this.$props.list_food = this.list_food.filter((detail) => {
            //     return detail.id != this.detail_edit_bill.id
            // })

            let dataList = this.list_food.filter((detail) => {
                return detail.id != this.detail_edit_bill.id
            })

            this.$emit('remove_food', dataList)


            // this.list_food = this.list_food.filter((detail) => {
            //     return detail.id != this.detail_edit_bill.id
            // })
        },
        // async beforePrint() {
        //     this.alert_confirm_before_print = false
        //     HTTP.post('/chage_status_bill_first/' + this.invoice_id, {
        //             discount: this.payment_amount_discount_all,
        //             total: this.payment_amount_total,
        //         }, {
        //             headers: {
        //                 "Authorization": `Bearer ${this.$store.state.token}`
        //             }
        //         })
        //         .then((response) => {
        //             if (response.data.successful === true) {
        //                 this.alert_print_bill = true
        //                 setTimeout(() => this.alert_print_bill = false, 5000)
        //             }

        //         }).catch((error) => {
        //             if (error.response.status === 401) {
        //                 this.$store.commit('logOutSuccess')
        //                 this.$router.push('/login')
        //             }
        //         })
        // },
        async openPaymentDiscount() {
            this.open_payment_discount = true
            this.add_payment_amount_discount = null
            this.add_payment_amount_discount_check = false
            this.add_payment_amount_discount_percent = null
            this.add_payment_amount_discount_percent_check = false
            this.payment_amount_discount_show = false
        },
        async checkTypeDiscount() {
            this.add_payment_amount_discount_check = false
            this.add_payment_amount_discount_percent_check = false
            this.payment_amount_discount_show = false
            if (this.add_payment_amount_discount) {
                this.add_payment_amount_discount_percent_check = true
                let payment_amount = parseFloat(this.list_food.reduce((sum, number) => { return sum + number.total_price}, 0))
                if (this.add_payment_amount_discount > payment_amount) {
                    this.payment_amount_discount_show = true
                }
            }
            if (this.add_payment_amount_discount_percent) {
                this.add_payment_amount_discount_check = true
                if (this.add_payment_amount_discount_percent > 100) {
                    this.payment_amount_discount_show = true
                }
            }
        },
        async paymentDiscount() {
            this.open_payment_discount = false
            this.payment_amount_total =this.list_food.reduce((sum, number) => { return sum + number.total_price}, 0)

            if (this.vat_service_charge_detail.vat != 2) {
                let vat_percent = 7 / 100
                this.vat_percent_result = this.payment_amount_total * vat_percent
                this.vat_percent_result = parseFloat(this.vat_percent_result).toFixed(2)
                this.vat_percent_result = parseFloat(this.vat_percent_result)
                if (this.vat_service_charge_detail.vat == 0) {
                    this.payment_amount -= this.vat_percent_result
                }
                if (this.vat_service_charge_detail.vat == 1) {
                    this.payment_amount_total += this.vat_percent_result
                }
            }

            if (this.vat_service_charge_detail.check_service_charge == 1) {
                let service_charge_percent =  this.vat_service_charge_detail.service_charge / 100
                this.service_charge_result = this.payment_amount_total * service_charge_percent
                this.service_charge_result = parseFloat(this.service_charge_result).toFixed(2)
                this.service_charge_result = parseFloat(this.service_charge_result)
                this.payment_amount_total += this.service_charge_result
            }

            this.payment_amount_discount = this.add_payment_amount_discount
            this.payment_amount_discount_percent = this.add_payment_amount_discount_percent

            let payment_amount = parseFloat(this.list_food.reduce((sum, number) => { return sum + number.total_price}, 0))
            if (this.payment_amount_discount > payment_amount) {
                this.payment_amount_discount = null
                this.payment_amount_discount_percent = null
                this.open_payment_discount_error = true
            }else if(this.payment_amount_discount_percent > 100){
                this.payment_amount_discount = null
                this.payment_amount_discount_percent = null
                this.open_payment_discount_error = true
            }else{
                if (this.payment_amount_discount) {
                    this.payment_amount_discount = parseFloat(this.payment_amount_discount).toFixed(2)
                    this.payment_amount_discount = parseFloat(this.payment_amount_discount)
                    this.payment_amount_total -= this.payment_amount_discount
                    this.payment_amount_discount_all = this.payment_amount_discount
                }

                if (this.payment_amount_discount_percent) {
                    let discount_percent = this.payment_amount_discount_percent / 100
                    let discount_percent_result = this.payment_amount_total * discount_percent
                    discount_percent_result = parseFloat(discount_percent_result).toFixed(2)
                    discount_percent_result = parseFloat(discount_percent_result)
                    this.payment_amount_total -= discount_percent_result
                    this.payment_amount_discount_all = discount_percent_result
                }
            }
        },
        async openCheckBill() {
            this.default_payment_amount_calculate_total = false
            this.payment_amount_calculate_total = this.payment_amount_total
            this.payment_amount_calculate_total_show = Intl.NumberFormat().format(this.payment_amount_calculate_total)
            this.preview_change_money = '0'
            this.open_check_bill = true
        },
        async calculate(value) {
            if (!this.default_payment_amount_calculate_total) {
                this.default_payment_amount_calculate_total = true
                this.payment_amount_calculate_total = '0'
            }
            if (this.payment_amount_calculate_total !== '0' && value !== 'remove' && value !== '.') {
                this.payment_amount_calculate_total += value
            }
            if (this.payment_amount_calculate_total === '0' && value !== 'remove' && value !== '.') {
                this.payment_amount_calculate_total = value
            }

            if (value === '.') {
                let checkDot = this.payment_amount_calculate_total.includes('.')
                if (checkDot === false) {
                    this.payment_amount_calculate_total += '.'
                }
            }

            if (value === 'remove' && this.payment_amount_calculate_total !== '0') {
                this.payment_amount_calculate_total = this.payment_amount_calculate_total.slice(0, -1)
                if (this.payment_amount_calculate_total === '') {
                    this.payment_amount_calculate_total = '0'
                }
            }

            if (value === 'clear') {
                this.payment_amount_calculate_total = '0'
            }

            if (value === '฿ 1000') {
                this.payment_amount_calculate_total = '1000'
            }

            if (value === '฿ 500') {
                this.payment_amount_calculate_total = '500'
            }

            if (value === '฿ 100') {
                this.payment_amount_calculate_total = '100'
            }

            if (value === 'full') {
                this.payment_amount_calculate_total = this.payment_amount_total.toString()
            }

            if (this.payment_amount_calculate_total > 1000000) {
                this.payment_amount_calculate_total = '1000000'
            }
        },
        async confirmPayment(type) {
            this.payment_type = type
            this.successPayment()

        },
        async successPayment() {
            // if (this.payment_type == 0) {
            //     let change_money = this.payment_amount_calculate_total - parseFloat(this.payment_amount_total)
            //     if (change_money >= 0) {
            //         this.loading_page_check_bill = true
            //         HTTP.post('/POS/table/check-bill-takehome', {
            //                 id: this.invoice_id,
            //                 price: this.payment_amount,
            //                 discount: this.payment_amount_discount_all,
            //                 total_price: this.payment_amount_total,
            //                 reccive_money: this.payment_amount_calculate_total,
            //                 change: change_money,
            //                 payment_method: this.payment_type,
            //             }, {
            //                 headers: {
            //                     "Authorization": `Bearer ${this.$store.state.token}`
            //                 }
            //             })
            //             .then((response) => {
            //                 if (response.data.successful === true) {
            //                     this.change_money_bill = change_money.toFixed(2)
            //                     this.change_money_bill = parseFloat(this.change_money_bill)
            //                     this.loading_page_check_bill = false
            //                     this.open_check_bill = false
            //                     this.alert_confirm_after_print = true
            //                 }
            //             }).catch((error) => {
            //                 if (error.response.status === 401) {
            //                     this.$store.commit('logOutSuccess')
            //                     this.$router.push('/login')
            //                 }
            //             })
            //     }
            // }
            // if (this.payment_type == 1) {
            //     this.loading_page_check_bill = true
            //     HTTP.post('/POS/table/check-bill-takehome', {
            //             id: this.invoice_id,
            //             price: this.payment_amount,
            //             discount: this.payment_amount_discount_all,
            //             total_price: this.payment_amount_total,
            //             reccive_money: this.payment_amount_total,
            //             change: 0,
            //             payment_method: this.payment_type,
            //         }, {
            //             headers: {
            //                 "Authorization": `Bearer ${this.$store.state.token}`
            //             }
            //         })
            //         .then((response) => {
            //             if (response.data.successful === true) {
            //                 this.loading_page_check_bill = false
            //                 this.open_check_bill = false
            //                 this.alert_confirm_after_print = true
            //             }
            //         }).catch((error) => {
            //             if (error.response.status === 401) {
            //                 this.$store.commit('logOutSuccess')
            //                 this.$router.push('/login')
            //             }
            //         })
            // }
            // if (this.payment_type == 2) {
            //     if (this.code_welfare_card == null && this.state_project == 1 || this.code_welfare_card == '' && this.state_project == 1) {

            //         this.message_error_welfare_card = "กรุณากรอกหมายเลขบัตรสวัสดิการ"
            //         this.alert_error_welfare_card = true
            //         setTimeout(() => this.alert_error_welfare_card = false, 5000)

            //     } else if (this.welfare_card_price == null && this.state_project == 1 || this.welfare_card_price == '' && this.state_project == 1) {

            //         this.message_error_welfare_card = "กรุณากรอกชำระจากบัตรสวัสดิการ"
            //         this.alert_error_welfare_card = true
            //         setTimeout(() => this.alert_error_welfare_card = false, 5000)

            //     } else if (this.welfare_card_price_excess == null && this.state_project == 1 || this.welfare_card_price_excess == '' && this.state_project == 1) {

            //         this.message_error_welfare_card = "กรุณากรอกชำระส่วนเกิน"
            //         this.alert_error_welfare_card = true
            //         setTimeout(() => this.alert_error_welfare_card = false, 5000)

            //     } else {
            //         this.loading_page_check_bill = true
            //         HTTP.post('/POS/table/check-bill-takehome', {
            //                 id: this.invoice_id,
            //                 price: this.payment_amount,
            //                 discount: this.payment_amount_discount_all,
            //                 total_price: this.payment_amount_total,
            //                 reccive_money: this.payment_amount_total,
            //                 change: 0,
            //                 payment_method: this.payment_type,
            //                 state_project: this.state_project,
            //                 code_welfare_card: this.code_welfare_card,
            //                 welfare_card_price: this.welfare_card_price,
            //                 welfare_card_status_excess: this.welfare_card_status_excess,
            //                 welfare_card_price_excess: this.welfare_card_price_excess,
            //             }, {
            //                 headers: {
            //                     "Authorization": `Bearer ${this.$store.state.token}`
            //                 }
            //             })
            //             .then((response) => {
            //                 if (response.data.successful === true) {
            //                     this.loading_page_check_bill = false
            //                     this.open_check_bill = false
            //                     this.alert_confirm_after_print = true
            //                 }
            //             }).catch((error) => {
            //                 if (error.response.status === 401) {
            //                     this.$store.commit('logOutSuccess')
            //                     this.$router.push('/login')
            //                 }
            //             })
            //     }
            // }
            if (this.payment_type == 0) {
                if (this.list_food.length > 0) {
                    this.loading_page_check_bill = true

                    let change_money = this.payment_amount_calculate_total - parseFloat(this.payment_amount_total)
                    let foodmenu_id = []
                    let amount = []
                    let menu_price = []
                    let menu_total_price = []
                    let toping_id = []
                    let menu_topping_price = []
                    let description = []

                    this.list_food.forEach(detail => {
                        let clear_topping_price = detail.toppingprice * detail.amount
                        let send_total_price = detail.total_price - clear_topping_price
                        foodmenu_id.push(detail.foodmenu_id)
                        amount.push(detail.amount)
                        menu_price.push(detail.price)
                        menu_total_price.push(send_total_price)
                        menu_topping_price.push(detail.toppingprice)
                        toping_id.push(detail.topping_arr_list)
                        description.push(detail.description)
                    });

                    HTTP.post('/fastOrdercreateTakhome', {
                            sub_total_price:this.list_food.reduce((sum, number) => { return sum + number.total_price}, 0),
                            discount:this.payment_amount_discount_all,
                            total_price: this.payment_amount_total,
                            reccive_money: this.payment_amount_calculate_total,
                            change: change_money,
                            payment_method: this.payment_type,
                            foodmenu_id: foodmenu_id,
                            amount: amount,
                            menu_price: menu_price,
                            menu_total_price: menu_total_price,
                            menu_topping_price: menu_topping_price,
                            toping_id: toping_id,
                            description: description,
                            price: this.payment_amount,
                            vat_price: this.vat_percent_result,
                            percen_service_charge: this.vat_service_charge_detail.check_service_charge == 1 ? this.vat_service_charge_detail.service_charge : null,
                            service_charge: this.vat_service_charge_detail.check_service_charge == 1 ? this.service_charge_result : null,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                // this.list_food = []
                                // this.loading_page_check_bill = false
                                // this.open_check_food = false
                                // this.alert_show_send_food = true
                                // setTimeout(() => this.alert_show_send_food = false, 5000)
                                // this.reset_bill = true
                                // setTimeout(() => this.reset_bill = false, 500)
                                this.$router.push('/poslist')

                            }
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                }
            }
            if (this.payment_type == 1) {
                if (this.list_food.length > 0) {
                    this.loading_page_check_bill = true
                    let foodmenu_id = []
                    let amount = []
                    let menu_price = []
                    let menu_total_price = []
                    let toping_id = []
                    let menu_topping_price = []
                    let description = []

                    this.list_food.forEach(detail => {
                        let clear_topping_price = detail.toppingprice * detail.amount
                        let send_total_price = detail.total_price - clear_topping_price
                        foodmenu_id.push(detail.foodmenu_id)
                        amount.push(detail.amount)
                        menu_price.push(detail.price)
                        menu_total_price.push(send_total_price)
                        menu_topping_price.push(detail.toppingprice)
                        toping_id.push(detail.topping_arr_list)
                        description.push(detail.description)
                    });

                    let payment_bank_type = 1
                    if (this.type_bank == 1) {
                        payment_bank_type = 3
                    }

                    HTTP.post('/fastOrdercreateTakhome', {
                            sub_total_price:this.list_food.reduce((sum, number) => { return sum + number.total_price}, 0),
                            discount:this.payment_amount_discount_all,
                            total_price: this.payment_amount_total,
                            reccive_money: this.payment_amount_total,
                            change: 0,
                            payment_method: payment_bank_type,
                            foodmenu_id: foodmenu_id,
                            amount: amount,
                            menu_price: menu_price,
                            menu_total_price: menu_total_price,
                            menu_topping_price: menu_topping_price,
                            toping_id: toping_id,
                            description: description,
                            price: this.payment_amount,
                            vat_price: this.vat_percent_result,
                            percen_service_charge: this.vat_service_charge_detail.check_service_charge == 1 ? this.vat_service_charge_detail.service_charge : null,
                            service_charge: this.vat_service_charge_detail.check_service_charge == 1 ? this.service_charge_result : null,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                // this.list_food = []
                                // this.loading_page_check_bill = false
                                // this.open_check_food = false
                                // this.alert_show_send_food = true
                                // setTimeout(() => this.alert_show_send_food = false, 5000)
                                // this.reset_bill = true
                                // setTimeout(() => this.reset_bill = false, 500)
                                this.$router.push('/poslist')

                            }
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                }
            }
            if (this.payment_type == 2) {
                if (this.list_food.length > 0) {
                    if (this.code_welfare_card == null && this.state_project == 1 || this.code_welfare_card == '' && this.state_project == 1) {
                        this.message_error_welfare_card = "กรุณากรอกหมายเลขบัตรสวัสดิการ"
                        this.alert_error_welfare_card = true
                        setTimeout(() => this.alert_error_welfare_card = false, 5000)

                    } else if (this.welfare_card_price == null && this.state_project == 1 || this.welfare_card_price == '' && this.state_project == 1) {

                        this.message_error_welfare_card = "กรุณากรอกชำระจากบัตรสวัสดิการ"
                        this.alert_error_welfare_card = true
                        setTimeout(() => this.alert_error_welfare_card = false, 5000)

                    } else if (this.welfare_card_price_excess == null && this.state_project == 1 || this.welfare_card_price_excess == '' && this.state_project == 1) {

                        this.message_error_welfare_card = "กรุณากรอกชำระส่วนเกิน"
                        this.alert_error_welfare_card = true
                        setTimeout(() => this.alert_error_welfare_card = false, 5000)

                    }else{
                    this.loading_page_check_bill = true
                    let foodmenu_id = []
                    let amount = []
                    let menu_price = []
                    let menu_total_price = []
                    let toping_id = []
                    let menu_topping_price = []
                    let description = []

                    this.list_food.forEach(detail => {
                        let clear_topping_price = detail.toppingprice * detail.amount
                        let send_total_price = detail.total_price - clear_topping_price
                        foodmenu_id.push(detail.foodmenu_id)
                        amount.push(detail.amount)
                        menu_price.push(detail.price)
                        menu_total_price.push(send_total_price)
                        menu_topping_price.push(detail.toppingprice)
                        toping_id.push(detail.topping_arr_list)
                        description.push(detail.description)
                    });

                    HTTP.post('/fastOrdercreateTakhome', {
                            sub_total_price:this.list_food.reduce((sum, number) => { return sum + number.total_price}, 0),
                            discount:this.payment_amount_discount_all,
                            total_price: this.payment_amount_total,
                            reccive_money: this.payment_amount_total,
                            change: 0,
                            payment_method: this.payment_type,
                            state_project: this.state_project,
                            code_welfare_card: this.code_welfare_card,
                            welfare_card_price: this.welfare_card_price,
                            welfare_card_status_excess: this.welfare_card_status_excess,
                            welfare_card_price_excess: this.welfare_card_price_excess,
                            foodmenu_id: foodmenu_id,
                            amount: amount,
                            menu_price: menu_price,
                            menu_total_price: menu_total_price,
                            menu_topping_price: menu_topping_price,
                            toping_id: toping_id,
                            description: description,
                            price: this.payment_amount,
                            vat_price: this.vat_percent_result,
                            percen_service_charge: this.vat_service_charge_detail.check_service_charge == 1 ? this.vat_service_charge_detail.service_charge : null,
                            service_charge: this.vat_service_charge_detail.check_service_charge == 1 ? this.service_charge_result : null,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                // this.list_food = []
                                // this.loading_page_check_bill = false
                                // this.open_check_food = false
                                // this.alert_show_send_food = true
                                // setTimeout(() => this.alert_show_send_food = false, 5000)
                                // this.reset_bill = true
                                // setTimeout(() => this.reset_bill = false, 500)
                                this.$router.push('/poslist')

                            }
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                    }
                }
            }
        },
        async afterPrint(type) {
            this.alert_confirm_after_print = false
            HTTP.post('/print_and_notprint/' + this.invoice_id, {
                    type: type,

                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.$router.push('/poslist')
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

        },
        async successCancelBill() {
            if (this.$refs.form_success_cancel_bill.validate()) {
                this.loading_page_success_cancel_bill = true
                let cancel_description = this.bill_cancel_description
                if (this.bill_cancel_description_reason_check) {
                    cancel_description = this.bill_cancel_description_reason
                }
                HTTP.post('/cancel_takehome/' + this.invoice_id, {
                        description: cancel_description
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.$router.push('/poslist')
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async cancel_cancelBill() {
            this.alert_confirm_cancel_bill = false
            this.bill_cancel_description = null
            this.bill_cancel_description_reason_check = false
            this.bill_cancel_description_reason = null
        },
        async billCancelDescription() {
            this.bill_cancel_description_reason_check = false
            if (this.bill_cancel_description == 'อื่นๆ') {
                this.bill_cancel_description_reason_check = true
            }
        },
        async page_check_bill(type) {
            this.type_page_check_bill = type
        },
        async stateProject(){
            this.code_welfare_card = null
            this.welfare_card_price = null
            this.welfare_card_status_excess = '0'
            this.welfare_card_price_excess = null
        },
        async input_welfare_card_price(type){
            if (type === 'welfare_card_price') {

                if (this.welfare_card_price == null || this.welfare_card_price == '') {
                    this.welfare_card_price_excess =  this.payment_amount_total - 0
                }else{
                    this.welfare_card_price_excess =  this.payment_amount_total - this.welfare_card_price
                }

                if (this.welfare_card_price_excess < 0) {
                    this.welfare_card_price_excess = 0
                }
                if (this.welfare_card_price_excess > this.payment_amount_total) {
                    this.welfare_card_price_excess = this.payment_amount_total
                }

                if (this.welfare_card_price > this.payment_amount_total) {
                    this.welfare_card_price = this.payment_amount_total
                }

            }

            if (type === 'welfare_card_price_excess') {

                if (this.welfare_card_price_excess == null || this.welfare_card_price_excess == '') {
                    this.welfare_card_price =  this.payment_amount_total - 0
                }else{
                    this.welfare_card_price =  this.payment_amount_total - this.welfare_card_price_excess
                }

                if (this.welfare_card_price < 0) {
                    this.welfare_card_price = 0
                }
                if (this.welfare_card_price > this.payment_amount_total) {
                    this.welfare_card_price = this.payment_amount_total
                }

                if (this.welfare_card_price_excess > this.payment_amount_total) {
                    this.welfare_card_price_excess = this.payment_amount_total
                }

            }
        },
    },
    watch: {
        payment_amount_calculate_total: function (value) {
            let point = value.split('.')
            let change_money = this.payment_amount_calculate_total - parseFloat(this.payment_amount_total)
            if (change_money <= 0) {
                change_money = 0
            }
            if (point.length >= 2) {
                this.payment_amount_calculate_total_show = Intl.NumberFormat().format(point[0]) + '.' + point[1]
                this.preview_change_money = Intl.NumberFormat().format(change_money)
            } else {
                this.payment_amount_calculate_total_show = Intl.NumberFormat().format(value)
                this.preview_change_money = Intl.NumberFormat().format(change_money)
            }

        },
        re_bill: function (value) {
            if (value === true) {
                this.getPaymentDetail()
            }
        }
    },

    mounted() {
        this.getPaymentDetail()

    }

}
</script>

<style scoped>
.cursor_payment_calculate {
    cursor: pointer;
}

.payment_image_menu {
    width: 10%;
}

.payment_image_menu>img {
    max-width: 100%;
}

.calculate_payment_food_new {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    font-size: 20px;
}

.calculate_payment_food_new>div {
    padding: 10px 15px;
    border-left: 2px #eeeeee solid;
    border-right: 2px #eeeeee solid;
    margin: 10px 0;
    color: #000000;
    cursor: pointer;
}

.calculate_payment_food_new>div:first-child {
    border-left: unset;
}

.calculate_payment_food_new>div:last-child {
    border-right: unset;
}

.calculate_shortcut {
    color: rgb(3, 140, 193) !important;
}

.calculate_border_bottom {
    border: 1px #eeeeee solid;
}

.calculate_change_new {
    display: grid;
    grid-template-columns: 50% 50%;
}

.calculate_change_new>div:first-child {
    border-right: 2px #eeeeee solid;
    padding-right: 15px;
}

.calculate_change_new>div:last-child {
    border-left: 2px #eeeeee solid;
    padding-left: 15px;
}

.change_all {
    color: #000000;
}

.change_all>div:first-child {
    font-size: 25px;
}

.change_all>div:last-child {
    font-size: 30px;
}

.line_government {
    border-top: 2px solid #cccccc;
}

.pay_all {
    display: grid;
    grid-template-columns: 50% 50%;
}
</style>
